import { isNil } from "lodash-es";

export const encodeUrlParams = (params: Record<string, unknown>) => {
  return new URLSearchParams(
    Object.entries(params)
      .filter(([_, value]) => !isNil(value))
      .map(([key, value]) => [key, String(value)]),
  );
};

export type UrlValueType = {
  url: string;
  name?: string;
};

export const isUrlValue = (value: unknown): value is UrlValueType =>
  typeof value === "object" &&
  value !== null &&
  typeof (value as UrlValueType).url === "string";
